import styled from '@emotion/styled';
import { Link } from 'components/link';
import { SmallText, Text } from 'ds/components/typography';
import { IOfficeAwardYear } from 'utils/entities';

export const BADGE_SIZE = {
  width: 222,
  height: 96,
};

const ICON_SIZE = 72;

export const BadgeWrapper = styled(Link)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: space-between;
  width: ${BADGE_SIZE.width}px;
  text-decoration: none;
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    width: 100%;
  `}
  height: ${BADGE_SIZE.height}px;
  border: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  padding: ${({ theme }) => theme.spacing(1.5)} ${({ theme }) => theme.spacing(2)};
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.neutrals.white};
`;

export const Icon = styled.div<{ year: IOfficeAwardYear; }>`
  width: ${ICON_SIZE}px;
  height: ${ICON_SIZE}px;
  line-height: 0;
  flex-shrink: 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    ${({ theme, year }) => year === IOfficeAwardYear.Y2025 || year === IOfficeAwardYear.Y2024 ? `
      padding: ${theme.spacing(0.25)};
    ` : ''}
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(0.25)};
  width: 100%;
`;

export const Title = styled(Text)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
`;

export const SubTitle = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey2};
`;
